import { buildUrl } from '../../../common/urlBuilder';
import Service from '../../../service';

export const getCityList = async (stateId) => {
  let url = buildUrl('v1/site-management/city');
  if (stateId) url += `?stateId=${stateId}`;

  return Service.get(url);
};

export const getAll = async (filteredData) => {
  let url = buildUrl('v1/site-management/travel-partners/pagination');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const getTravelPartnerAll = async (filteredData) => {
  let url = buildUrl('v1/site-management/travel-partners');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const findById = async (id) => {
  let url = buildUrl(`v1/site-management/travel-partners/${id}`);

  return Service.get(url);
};

export const create = async (data) => {
  let url = buildUrl('v1/site-management/travel-partners');

  return Service.post(url, data);
};

export const update = async (data, id) => {
  let url = buildUrl(`v1/site-management/travel-partners/${id}`);
  return Service.put(url, data);
};

export const deleteTravelPartner = async (id) => {
  let url = buildUrl(`v1/site-management/travel-partners/${id}`);
  return Service.delete(url);
};